import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import Header from '@carvana/header';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { getIsOnOpdRouteOrSignout } from '@carvana/purchase-utils';
import { useIsInBucket } from '@carvana/purchase-helpers';
import { HeaderWrapper } from './header.styles';
import PurchaseHeader from './purchase-header';

function CarvanaHeader({
  isLoggedIn,
  location,
  vehicleTotalPrice,
  chatContext,
  vehicleLock,
  navigationConfig,
  vehicle,
  isMobile,
  orderState,
  isLoading
}) {
  const isInPurchaseHeaderBucket = useIsInBucket(
    'pp-purchase-header-dec-2023',
    'purchase-header',
    ['control']
  );

  const hideHeader = Cookies.get('hide-header') === 'true' ? true : false;
  const shouldHideHeader =
    /CarvanaNativeWebView/gi.test(navigator?.userAgent) && hideHeader;
  const isOnOpdRouteOrSignout = getIsOnOpdRouteOrSignout(location);
  const hasSubNavOnMobile =
    isLoggedIn && !isOnOpdRouteOrSignout && !shouldHideHeader;
  const currentRoute = (location && location.pathname) || '';

  const Head = memo(({ Component = Header }) => (
    <Component
      environment={process.env.CVNA_APP_ENVIRONMENT}
      isLoggedInExternally={isLoggedIn}
      purchaseProcessVehiclePrice={vehicleTotalPrice}
      useProvider
      currentRoute={currentRoute}
      chatContext={chatContext}
      shouldLoadPlugin={false}
    />
  ));
  Head.propTypes = {
    Component: PropTypes.shape({})
  };
  Head.defaultProps = {
    Component: Header
  };

  if (isInPurchaseHeaderBucket === null) return null;

  const showGlobalHeader =
    location.pathname.includes('vehicle/confirmation') ||
    location.pathname.includes('vehicle/missing') ||
    location.pathname.includes('vehicle/unavailable') ||
    location.pathname.includes('vehicle/sold-on-lot');

  const showPurchaseHeader =
    isInPurchaseHeaderBucket &&
    !location.pathname.includes('order-placed') &&
    !showGlobalHeader;

  return (
    <>
      {showPurchaseHeader ? (
        <PurchaseHeader
          hideHeader={shouldHideHeader}
          vehicleTotalPrice={vehicleTotalPrice}
          vehicleLock={vehicleLock}
          navigationConfig={navigationConfig}
          vehicle={vehicle}
          isMobile={isMobile}
          orderState={orderState}
          isLoading={isLoading}
        />
      ) : (
        <HeaderWrapper showPaddingOnMobile={hasSubNavOnMobile}>
          <MfeReactComponent
            component="default"
            module="HeaderModule"
            loading={<Head />}
          >
            {({ Component: HeaderComponent }) => (
              <Head Component={HeaderComponent} />
            )}
          </MfeReactComponent>
        </HeaderWrapper>
      )}
    </>
  );
}

CarvanaHeader.propTypes = {
  location: PropTypes.shape({}).isRequired,
  isLoggedIn: PropTypes.bool,
  vehicleTotalPrice: PropTypes.number,
  chatContext: PropTypes.shape({}),
  shouldRefreshProfileInHeader: PropTypes.bool
};

CarvanaHeader.defaultProps = {
  isLoggedIn: false,
  vehicleTotalPrice: 0,
  chatContext: {},
  shouldRefreshProfileInHeader: false
};

export default CarvanaHeader;
